import { useState } from "react";
import PropTypes from "prop-types";
import ProcessRow from "../ProcessRow";
import SendTilausVahvistusModal from "src/components/comms/SendTilausVahvistusButton/SendTilausVahvistusModal";

export default function ProcessRowTilausvahvistus(props) {
  const thisProcess = props.thisProcess;
  const keikkaData = props.thisProcess.keikkaData;
  const isConfirmed = props.thisProcess.tilausvahvistusLähetetty.isConfirmed;
  const isFound = props.thisProcess.tilausvahvistusLähetetty.isFound;
  const firstFoundDate = props.thisProcess.tilausvahvistusLähetetty.firstFoundDate;
  const firstConfirmDate = props.thisProcess.tilausvahvistusLähetetty.firstConfirmDate;

  const [sendTilausvahvistusModalIsOpen, setSendTilausvahvistusModalIsOpen] = useState(false);

  const handleTextKlik = () => setSendTilausvahvistusModalIsOpen(true);
  const handleCheckKlik = () => {
    if (isConfirmed) {
      thisProcess.tilausvahvistusHylkää();
    } else {
      thisProcess.tilausvahvistusHyväksy();
    }
    thisProcess._tilausvahvistusLähetetty.isConfirmed = !isConfirmed;
    thisProcess._tilausvahvistusLähetetty.isFound = !isConfirmed;
    props.setThisProcess(thisProcess);
  };

  const handleSendTilausvahvistusModalClose = async () => {
    setSendTilausvahvistusModalIsOpen(false);
    props.reloadProcess();
  };

  return (
    <>
      <SendTilausVahvistusModal
        open={sendTilausvahvistusModalIsOpen}
        close={handleSendTilausvahvistusModalClose}
        keikkaData={keikkaData}
      />
      <ProcessRow
        txt="Tilausvahvistus lähetetty"
        textTip="Avaa tilausvahvistuksen lähetysikkuna"
        checkTip="Poista/lisää tilausvahvistuksen lähetysmerkintä"
        done={isFound}
        pvm={firstFoundDate}
        pvm2={firstConfirmDate}
        onCheckClick={() => handleCheckKlik()}
        onTextClick={() => handleTextKlik()}
        aria-label="Tilausvahvistus lähetetty"
        helpId="processRowTilausvahvistusLähetetty"
      />
    </>
  );
}

ProcessRowTilausvahvistus.propTypes = {
  thisProcess: PropTypes.object,
  reloadProcess: PropTypes.func,
  setThisProcess: PropTypes.func,
};
